import { render, staticRenderFns } from "./WaybillInfoModal.vue?vue&type=template&id=0ff71e08&scoped=true&"
import script from "./WaybillInfoModal.vue?vue&type=script&lang=js&"
export * from "./WaybillInfoModal.vue?vue&type=script&lang=js&"
import style0 from "./WaybillInfoModal.vue?vue&type=style&index=0&id=0ff71e08&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0ff71e08",
  null
  
)

export default component.exports